import React, { useState, useEffect } from 'react';
import { styles } from '../../Stylesheet';
import { revokeToken } from '../../Utils/session-utils';
import { Grid, Paper, Container, Typography, Divider, Button } from '@material-ui/core';
import { SuccessView } from '../common/ConfirmationViews/ConfirmationViews';
const CCConfirmation = () => {
    const classes = styles();
    useEffect(()=>{
        revokeToken();
    },[]);
    return (
        <Container >
            <Typography style={{fontSize: "48px",fontWeight: 400, padding: "1em 0 1rem", letterSpacing: "0.5px",
                lineHeight: "55px",
                fontFamily: '"Chronicle Text G1", "Frank Ruhl Libre", serif',
                position: "relative",
                marginBottom: "1em",
            }}>Ascension Rx Payment Details <Divider style={{borderBottom: "6px solid #B40F87", width: 40}}/></Typography>
            <SuccessView >
                Your payment information was successfully added.
                <ul >
                    <li>Your card will remain on file to make your next fill easy and hassle-free.</li>
                    <li style={{marginBottom:"10px"}}>You can safely close this browser window or tab.</li>
                  
                  
               
                <Button  variant="contained"
                            size="large"
                            className={classes.submitButton}
                            color="primary">  <a href="https://ascension.medrefill.com/asweb/#/refill" style={{color:"white",textDecoration:"none"}}>Request Refill</a>     </Button>
                             &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp;

<Button  variant="contained"
                            size="large"
                            className={classes.submitButton}
                            color="primary">  
                           <a href="https://id.ascension.org/id.ascension.org/oauth2/v2.0/authorize?p=B2C_1A_SIGNUP_SIGNIN_CONSUMER&client_id=6fae3d6f-a240-43b8-9070-2b6dd4313acd&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fheimdall.medrefill.com%2Fas%2Flogin&scope=openid%20offline_access&response_type=code&prompt=login&state=eyJzb3VyY2UiOiJXQiJ9"  style={{color:"white",textDecoration:"none"}}>Check Rx Status</a>
  </Button>
 

  </ul>  


                 </SuccessView>
        </Container>
    )
}

export default CCConfirmation;

